import { NAV_FETCHED } from "../types";

const initialState = {
    menu: {
        header: 'All Categories',
        children: []

    },
    loaded:false
};

export default function navigation(state = initialState, action) {
  switch (action.type) {
    case NAV_FETCHED:
      return Object.assign({}, action.nav);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js